export default __webpack_public_path__ + "static/media/full-dwarf.5e85507c.jpg";